<template>
    <!-- 上传图片
         @author: 王汝鹏
         @date: 2019-9-16
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :rules="validatorRule"
                     :variableName="model"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-upload class="form-item_upload"
                 :class="{'is-limited': showFileListData.length >= uploadLimit}"
                 :action="uploadHost"
                 :limit="uploadLimit"
                 :http-request="uploadImage"
                 :on-preview="handlePictureCardPreview"
                 :on-remove="handleRemove"
                 :on-exceed="handleExceed"
                 :on-move="move"
                 :file-list="showFileListData"
                 accept="image/jpeg, image/gif, image/png"
                 :drag-move=true
                 :multiple=true
                 list-type="picture-card">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="imgPreview.visible">
        <img width="100%" :src="dialogManage(this.imgPreview).data" alt="">
      </el-dialog>
    </div>          
  </preview-form-item>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixUpload 上传图片/文件混入
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import mixUpload from '@/mixins/common/mix_upload.js';
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";
/** 工具方法 ::: 
 *  @function dialogDefaultConfig 生成对话框默认配置方法
 *  @function dialogManage 对话框管理者
 */
import { dialogDefaultConfig, dialogManage } from "@/utils/dialog_manage.js";


export default {
  mixins: [
    mixUpload,
    mixPreviewItemTemplateChild
  ],
  data() {
    return {
      imgPreview: dialogDefaultConfig(),
    }
  },
  methods: {
    dialogManage,
    /** @name 预览图片
     *  @param {Object} file 文件对象
     *  @author 王汝鹏
     *  @version 2019-09-16
     */
    handlePictureCardPreview(file) {
      dialogManage(this.imgPreview).show(file.url);
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemUploadImage.vue